<template>
	<div class="row referencia" :id="id">
		<div class="col-3">
			<b-select :id="'refe_' + id" :name="'refe_' + id" size="sm" 
				:plain="true" :value="getRefe" :options="lista" value-field="id" text-field="tag" class="referencia-refe" placeholder="Referencia"></b-select>
		</div>
		<div class="col-2">
			<b-input-group size="sm" prepend="Nº">
				<b-form-input :id="'numero_' + id" :name="'numero_' + id" 
					:value="getNumero" size="sm" class="referencia-numero" placeholder="Ingresar Nº"></b-form-input>
			</b-input-group>
		</div>
		<div class="col-3">
			<b-input-group size="sm" prepend="Fecha">
				<date-picker :id="'fecha_' + id" :name="'fecha_' + id" :value="getFecha" class="referencia-fecha" placeholder="Ingresar Fecha"
					:config="{ format: 'DD/MM/YYYY', locale: 'es' }">
				</date-picker>
			</b-input-group>
		</div>
		<div class="col-4">
			<b-input-group size="sm" prepend="Comentario">
				<b-form-input :id="'comentario_' + id" :name="'comentario_' + id" 
					:value="getComentario" size="sm" placeholder="Ingresar Comentario" class="referencia-comentario"></b-form-input>
			</b-input-group>
		</div>
	</div>
</template>
<script lang="ts">

	import { uuid } from "vue-uuid"
	import moment from "moment"


	export default {
		name: "Referencia",
		props: {
			referencia: Object, // Si se creo una factura y se esta editando, los datos de las referencias vienen en este objeto
		},
		data() {
			return {
				id: "", // ID unico del componente
				lista: [ 
					{ href: "", tag: "Referencia", id: null, state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/28.json", tag: "AWB (Air Will Bill)", id: "809", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/27.json", tag: "B/L (Conocimiento de embarque)", id: "808", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/35.json", tag: "Boleta", id: "35", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/10.json", tag: "Boleta Electrónica", id: "39", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/1.json", tag: "Boleta Exenta", id: "38", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/11.json", tag: "Boleta Exenta Electrónica", id: "41", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/30.json", tag: "Carta de Porte", id: "811", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/33.json", tag: "Certificado de Depósito Bolsa Prod. Chile", id: "814", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/22.json", tag: "Contrato", id: "803", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/38.json", tag: "Declaración de Ingreso (DIN)", id: "914", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/26.json", tag: "DUS", id: "807", state: 1 }, 
					{ href: "https://api.bsale.cl/v1/dte_codes/36.json", tag: "Factura", id: "30", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/2.json", tag: "Factura de Compra", id: "45", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/12.json", tag: "Factura de Compra Electrónica", id: "46", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/39.json", tag: "Factura de exportación", id: "101", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/17.json", tag: "Factura de Exportación Electrónica", id: "110", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/8.json", tag: "Factura Electrónica", id: "33", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/37.json", tag: "Factura Exenta", id: "32", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/9.json", tag: "Factura No Afecta o Exenta Electrónica", id: "34", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/25.json", tag: "Ficha ChileCompra", id: "806", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/15.json", tag: "Guía de Despacho", id: "50", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/16.json", tag: "Guía de Despacho Electrónica", id: "52", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/44.json", tag: "HEM", id: "HEM", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/43.json", tag: "HES", id: "HES", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/5.json", tag: "Liquidación", id: "103", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/6.json", tag: "Liquidación Factura", id: "40", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/7.json", tag: "Liquidación-Factura Electrónica", id: "43", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/29.json", tag: "MIC/DTA", id: "810", state: 1 }, 
					{ href: "https://api.bsale.cl/v1/dte_codes/4.json", tag: "Nota de Crédito", id: "60", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/41.json", tag: "Nota de Crédito de exportación", id: "106", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/19.json", tag: "Nota de Crédito de Exportación Electrónica", id: "112", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/14.json", tag: "Nota de Crédito Electrónica", id: "61", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/3.json", tag: "Nota de Débito", id: "55", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/40.json", tag: "Nota de débito de exportación", id: "104", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/18.json", tag: "Nota de Débito de Exportación Electrónica", id: "111", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/13.json", tag: "Nota de Débito Electrónica", id: "56", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/21.json", tag: "Nota de pedido", id: "802", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/20.json", tag: "Orden de Compra", id: "801", state: 0 },
					{ href: "https://api.bsale.cl/v1/dte_codes/32.json", tag: "Pasaporte", id: "813", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/24.json", tag: "Proceso ChileCompra", id: "805", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/23.json", tag: "Resolución", id: "804", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/31.json", tag: "Resolución del SNA donde califica Servicios de Exportación", id: "812", state: 1 },
					{ href: "https://api.bsale.cl/v1/dte_codes/34.json", tag: "Vale de Prenda Bolsa Prod. Chile", id: "815", state: 1 }, 
					{ href: "https://api.bsale.cl/v1/dte_codes/42.json", tag: "Vales comprobantes de Pago Medios Electrónicos (Transbank)", id: "48", state: 1 }   
				],
			}
		},
		created() {

			// ID unico asignado a este objeto
			this.id = uuid.v1()
		},
        mounted: function() {

			// Informamos al componente "AgregarGlosa" el ID asignado a este objeto
			// Esto se hace para poder eliminar la fila desde el boton "-"
			this.$emit("evento-objeto-id", { tipo: 1, id: this.id })
		},
		computed: {

			// Devuelve la referencia
			getRefe() {

				var value = null
				if (this.referencia != undefined)
					value = this.referencia.codeSii

				return value
			},

			// Devuelve el Numero
			getNumero() {

				var value = ""
				if (this.referencia != undefined)
					value = this.referencia.number

				return value
			},

			// Devuelve la Fecha
			getFecha() {

				var value = ""
				if (this.referencia != undefined)
					value = moment.unix(this.referencia.referenceDate).format("DD/MM/YYYY")

				return value
			},

			// Devuelve el comentario
			getComentario() {

				var value = ""
				if (this.referencia != undefined)
					value = this.referencia.reason

				return value
			}
		}
	}
</script>
<style scoped>

	.referencia {
		margin-bottom: 5px;
	}
</style>